
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSpiideoCompetitorMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spiideo_team_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sportradar_srt_url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ligr_srt_url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSpiideoCompetitorMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"competitor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitor"}}},{"kind":"Argument","name":{"kind":"Name","value":"spiideo_team_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spiideo_team_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"sportradar_srt_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sportradar_srt_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"ligr_srt_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ligr_srt_url"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSpiideoCompetitorMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spiideo_team_uuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sportradar_srt_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ligr_srt_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSpiideoCompetitorMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"competitor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitor"}}},{"kind":"Argument","name":{"kind":"Name","value":"spiideo_team_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spiideo_team_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"sportradar_srt_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sportradar_srt_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"ligr_srt_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ligr_srt_url"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSpiideoCompetitorMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSpiideoCompetitorMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[]}]}}],"loc":{"start":0,"end":891}};
    doc.loc.source = {"body":"mutation CreateSpiideoCompetitorMapping(\n    $competitor: ID!\n    $spiideo_team_uuid: String!\n    $sportradar_srt_url: String!\n    $ligr_srt_url: String!\n) {\n    createSpiideoCompetitorMapping(\n        competitor: $competitor\n        spiideo_team_uuid: $spiideo_team_uuid\n        sportradar_srt_url: $sportradar_srt_url\n        ligr_srt_url: $ligr_srt_url\n    ) {\n        id\n    }\n}\n\nmutation UpdateSpiideoCompetitorMapping(\n    $id: ID!\n    $competitor: ID\n    $spiideo_team_uuid: String\n    $sportradar_srt_url: String\n    $ligr_srt_url: String\n) {\n    updateSpiideoCompetitorMapping(\n        id: $id\n        competitor: $competitor\n        spiideo_team_uuid: $spiideo_team_uuid\n        sportradar_srt_url: $sportradar_srt_url\n        ligr_srt_url: $ligr_srt_url\n    ) {\n        id\n    }\n}\n\nmutation DeleteSpiideoCompetitorMapping($id: ID!) {\n    deleteSpiideoCompetitorMapping(id: $id)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CreateSpiideoCompetitorMapping"] = oneQuery(doc, "CreateSpiideoCompetitorMapping");
        
        module.exports["UpdateSpiideoCompetitorMapping"] = oneQuery(doc, "UpdateSpiideoCompetitorMapping");
        
        module.exports["DeleteSpiideoCompetitorMapping"] = oneQuery(doc, "DeleteSpiideoCompetitorMapping");
        
